import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ResetViewsToolComponent } from './reset-views-tool.component';
import { CustomButtonsModule } from '@shared/buttons';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [TranslateModule, CustomButtonsModule, MatTooltipModule],
  declarations: [ResetViewsToolComponent],
  exports: [ResetViewsToolComponent],
  providers: [],
})
export class ResetViewsToolModule {}
